export enum DocumentTypeFields {
    NAME = 'name',
    DESCRIPTION = 'description',
    PROVIDERS = 'providers',
    IS_REQUIRED = 'isRequired',
}
